import * as CubeTree from '../../cubeTree/index';
import * as Toolkit from '../../toolkit/index';
import Utils from '../../utils/util';
import CodiSystem from '../../codiSystem/index';
import Config from '../../config/index';

const footerPhysicsArea: PhysicsCoordinate = Config.get({
    moduleName: 'sketchpad',
    key: 'footerPhysicsArea'
});

// 画布下方是否是空区域
function stageFooterIsEmpty(): boolean {
    let footerAreaLogicCoordinate: LogicCoordinate = CodiSystem.physicsToLogic(footerPhysicsArea);
    let beContainCubeIds: Array<CubeId> = CodiSystem.getInTargetLogicRectCubeIds(footerAreaLogicCoordinate);

    return beContainCubeIds.length === 0;
}

export {
    stageFooterIsEmpty
}
